<template>
  <commonTable :fields="queryResultTableFields" :items="queryResultTableItems">
    <template #header>查詢結果</template>
  </commonTable>
</template>

<script>
import commonTable from "@/components/commonTable.vue";
import { ref } from "vue";
export default {
  name: "queryResultTable",
  components: {
    commonTable,
  },
  props: {
    queryResultTableItems: {
      type: Array,
      default: [],
    },
    dateHour: {
      type: Boolean,
      default: false,
    },
    statisticalReports: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    //查詢結果表格
    console.log(props.dateHour);
    const queryResultTableFields = ref([]);
    if (props.dateHour == true) {
      queryResultTableFields.value = [
        {
          key: "date",
          label: "日期",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "time",
          label: "時間",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "site",
          label: "廠區",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "oper",
          label: "製程",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "group",
          label: "組別",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "device",
          label: "機台",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
      ];
    } else if (props.statisticalReports == true) {
      queryResultTableFields.value = [
        {
          key: "year",
          label: "年度",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "month",
          label: "月份",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "site",
          label: "廠區",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "oper",
          label: "站別",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "device",
          label: "機台",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
      ];
    } else {
      queryResultTableFields.value = [
        {
          key: "date",
          label: "日期",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "site",
          label: "廠區",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "oper",
          label: "製程",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "group",
          label: "組別",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
        {
          key: "device",
          label: "機台",
          thStyle: {
            "font-size": "16px",
          },
          tdStyle: {
            "font-size": "16px",
          },
        },
      ];
    }

    return {
      queryResultTableFields,
    };
  },
};
</script>

<style></style>
